import { IndividualReportView } from "@/components/IndividualReportView";
import { TrackingWorksheet } from "@/components/TrackingWorksheet";
import { useQuestions } from "@/lib/useInsights";
import { sortedTopics } from "@/lib/topics";
import { WorkbookProvider } from "@/lib/workbook";

export const ReportWithWorksheet = ({ data, max, token, editable = false, children }) => {
  const q = useQuestions();
  const topics = q ? sortedTopics(data.answers, q.questions) : [];
  return (
    <WorkbookProvider token={token || data.report_token} editable={editable}>
      <div className="space-y-8">
        <div className="report-pages space-y-8">
          <IndividualReportView data={data} max={max} topics={topics} descriptions={q?.descriptions} />
          {children}
        </div>
        <TrackingWorksheet data={data} topics={topics} />
      </div>
    </WorkbookProvider>
  );
};
